import Note, { type NoteProps } from '@liquidweb-dev/undercurrent/Note';
import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

export interface PageLayoutNoteProps extends StackProps {
	noteProps?: NoteProps;
}

const PageLayoutNote = ({
	children,
	noteProps,
	...rest
}: PageLayoutNoteProps) => {
	const { sx: noteSx, ...restNoteProps } = noteProps || {};

	return (
		<Stack
			{...rest}
			sx={[
				{
					paddingX: 250,
					alignItems: 'center',
				},
				...(Array.isArray(rest.sx) ? rest.sx : [rest.sx]),
			]}
		>
			<Note
				sx={combineSx(
					{
						marginX: 'auto',
						borderTopLeftRadius: 0,
						borderTopRightRadius: 0,
						borderTop: 'none',
						typography: 'body-sm',
					},
					noteSx,
				)}
				{...restNoteProps}
			>
				{children}
			</Note>
		</Stack>
	);
};

export default PageLayoutNote;
